import { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";

import { useProfileStore } from "@/store/profile.store";

/**
 * Sets the the profile SSOid as the user id in Datadog RUM
 * We only want to set the user id if it is not already set
 */
const useSetDataDogUserId = () => {
  const { profile } = useProfileStore();
  useEffect(() => {
    const dataDogUser = datadogRum.getUser();

    if (profile?.SSOid && dataDogUser?.id !== profile?.SSOid) {
      datadogRum.setUser({
        id: profile.SSOid,
      });
    }
  }, [profile]);
};

export default useSetDataDogUserId;
